import React, { useState, useRef, useEffect } from "react";
import useOnClickOutside from "use-onclickoutside";
import {
  TD,
  CellWrapper,
  CellInput,
  CellValue,
  CellOptionsWrapper,
  CellButton,
  CellIcon,
} from "../styledEdit";

const Cell = ({ rowIdx, cellIdx, cell, cols, onChange, setSettingsDraft }) => {
  const { expr, defaultValue } = cell;

  const [selected, setSelected] = useState(false);
  const [stateValue, setStateValue] = useState(expr || defaultValue || "");
  const [hovered, setHovered] = useState(false);

  const ref = useRef();
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [selected]);

  const changeValue = () => {
    setSelected(false);

    onChange({
      type: "row",
      rowIdx,
      cellIdx,
      key: "expr",
      value: stateValue.startsWith("=") ? stateValue : "",
    });
    onChange({
      type: "row",
      rowIdx,
      cellIdx,
      key: "defaultValue",
      value: stateValue.startsWith("=") ? "" : stateValue,
    });
  };

  useOnClickOutside(ref, () => changeValue());

  const onKeyPress = (e) => {
    if (e.which === 13) {
      changeValue();
    }
  };

  const col = cols[cellIdx];

  const hidden = col?.hidden || cell?.hidden;

  return (
    <TD isHidden={hidden}>
      <CellWrapper
        ref={ref}
        onClick={() => !selected && setSelected(true)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {hovered && (
          <CellOptionsWrapper>
            <CellButton
              onClick={(e) => {
                e.stopPropagation();
                setSettingsDraft({ type: "cell", data: cell, rowIdx, cellIdx });
              }}
            >
              <CellIcon className="fas fa-cog" />
            </CellButton>
          </CellOptionsWrapper>
        )}
        {selected ? (
          <CellInput
            ref={inputRef}
            value={stateValue}
            onChange={(e) => setStateValue(e.target.value)}
            onKeyPress={onKeyPress}
          />
        ) : (
          <CellValue isHidden={hidden}>
            {expr ? (
              <CellIcon
                className="fas fa-calculator"
                style={{ color: "#777" }}
              />
            ) : (
              defaultValue
            )}
          </CellValue>
        )}
      </CellWrapper>
    </TD>
  );
};

export default Cell;
